import { useGetAddOnsForPayload } from './use-get-addons-for-payload';

/** @typedef {import('../../../../api/subscription-types').ChangePlanRequest} ChangePlanRequest */

/**
 * Returns the shaped payload ready for the POST call to update the user's plan
 * @param {import('../types').PlanDetails} promotionalPlanDetails
 * @returns {ChangePlanRequest}
 */
export const useGetPayload = (promotionalPlanDetails) => {
  const { addOnsToRemove, addOnsToPurchase } = useGetAddOnsForPayload({
    promotionalPlanShipmentLimit: promotionalPlanDetails?.shipmentLimit?.limit,
  });

  if (!promotionalPlanDetails) {
    return null;
  }

  const payload = {
    changePlanRequest: {
      newPlanCode: promotionalPlanDetails.billingPlanCode,
      isDowngradeCancellation: false,
      skipUsersError: true,
      shouldForceChangeNow: true,
    },
    addOnsToPurchase,
    addOnsToRemove,
    paymentMethodId: null,
  };

  return payload;
};
